import React from "react";
import { Revote, Tuning2 } from "@solar-icons/react";
import { IoGridOutline } from "react-icons/io5";
import { IoIosArrowUp } from "react-icons/io";
import useFiles from "../context/FileContext";
import { FaList, FaRegStar } from "react-icons/fa";
import { useState } from "react";
import { getAllFolder } from "../api/folderapi";
import { useEffect } from "react";
import FileContainer from "../Component/FileContainer";
import { HiDotsVertical } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { FileContext } from "../context/FileContext";
import folderIcon from "../Assets/folder.png";
import { toast } from "react-hot-toast";
import MoveModal from "../Component/MoveModel";
import FileInformation from "../Component/FileInformation";
import ShareView from "../Component/ShareView";
import { getFileIcon } from "../utils/Icon";
import { FaLock } from "react-icons/fa";
import { value } from "../data/item";
import { useRef } from "react";
import { deleteFolder } from "../api/folderapi";
import DeleteView from "../Component/DeleteView";
import { useContext, useMemo } from "react";
import MenuComponent from "../Component/MenuComponent";
import { formatBytes } from "../utils/sizeCalculater";
import FilterContainer from "../Component/FilterContainer";

const MyDrive = () => {
  const { files, setFiles, viewType, setViewType, search } = useFiles();
  const [showAll, setShowAll] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [menuOpenId, setMenuOpenId] = useState(false);
  const [copiedFile, setCopiedFile] = useState(null);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [infoFile, setInfoFile] = useState(null);
  const [renameValue, setRenameValue] = useState("");
  const [selectedForMove, setSelectedForMove] = useState(null);
  const [renamingId, setRenamingId] = useState(null);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const menuRef = useRef(null);
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [selectedFolderForDelete, setSelectedFolderForDelete] = useState(null);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(null);
  const [datas, setDatas] = useState([]);
  const [infoModel, setInfoModel] = useState(false);
  const [checkboxOpen,setCheckboxOpen] = useState(false)
  const [selectedItems, setSelectedItems] = useState([]);

  const navigate = useNavigate();

  const handleItemClick = (item) => {
    if (item.type === "folder") {
      navigate("/folder/" + item._id);
    } else {
      setSelectedFile(item);
    }
  };

  const fetchFolders = async () => {
    try {
      setIsLoading(true);
      const res = await getAllFolder();
      setDatas(res.data);
      const rootFolders = res.data.filter((d) => d.type === "folder");
      setFiles(rootFolders);
    } catch (error) {
      console.error("Error fetching folders:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFolderClick = (folder) => {
    if (folder.isLocked) {
      const enteredPassword = prompt(
        "This folder is locked. Enter the password:"
      );
      if (enteredPassword !== folder.password) {
        alert("Incorrect password! Access denied.");
        return;
      }
    }

    if (folder.isDirectory) {
      setBreadcrumb((prev) => [...prev, folder]);
      setCurrentFolder(folder);
    } else {
      console.log("File clicked (no drill‐down):", folder.name);
    }
  };

  const handleDeleteConfirm = async (_id, name) => {
    try {
      if (selectedFolderForDelete) {
        const res = await deleteFolder(selectedFolderForDelete._id);

        toast.success(res.message);
        fetchFolders();
        setIsPopupOpen(false);
        setSelectedFolderForDelete(null);
        setMenuOpen(null);
      }
    } catch (error) {
      toast.error("Error deleting folder");
    }
  };

  const handleDeleteCancel = () => {
    setIsPopupOpen(false);
    setSelectedFolderForDelete(null);
  };

  const displayedFiles = useMemo(() => {
    let filtered = currentFolder ? [...currentFolder.items] : [...files];

    if (search) {
      filtered = filtered.filter((file) =>
        file.name?.toLowerCase().includes(search.toLowerCase())
      );
    }

    return filtered;
  }, [files, currentFolder, search]);

   useEffect(() => {
    getAllFolder()
      .then((res) => {
        const folders = res.data.filter((item) => item.type === "folder");
        setItems(folders);
      })
      .catch((err) => console.log(err));
  }, []); 

   

    const toggleSelection = (fileId) => {
  setSelectedItems((prev) =>
    prev.includes(fileId)
      ? prev.filter((id) => id !== fileId)
      : [...prev, fileId]
  );
};

  return (
    <div className="  mt-[10%] md:mt-[4%]">
      <div className=" flex justify-between mt-10 md:mt-5">
        <h4 className="text-secondary font-semibold text-xl">MyDrive</h4>

        <div className="flex justify-end gap-3 ">
          <div className="hidden md:w-10 h-10 border border-gray-300 rounded-md md:flex items-center justify-center hover:bg-gray-100 cursor-pointer">
              <Revote onClick={() => setCheckboxOpen(!checkboxOpen)}/>
             </div>
          <div className="hidden md:w-10 h-10 border border-gray-300 rounded-md md:flex items-center justify-center hover:bg-gray-100 cursor-pointer">
            <Tuning2 onClick={() => setShowFilter(!showFilter)} />
              {/*  {showFilter && <FilterContainer setShowFilter={setShowFilter} />} */}
          </div>

          <div className="flex border border-gray-300  rounded-md overflow-hidden w-fit h-10">
            <button
              className={`w-10 h-10 flex items-center justify-center transition duration-200 ${
                viewType === "list" ? "bg-four text-black" : "text-secondary "
              }`}
              onClick={() => {
                setViewType("list");
                setIsMenuOpen(false);
              }}
            >
              <FaList />
            </button>

            <button
              className={`w-10 h-10 flex items-center justify-center transition duration-200 ${
                viewType === "grid" ? "bg-four text-black" : "text-secondary "
              }`}
              onClick={() => {
                setViewType("grid");
                setIsMenuOpen(false);
              }}
            >
              <IoGridOutline />
            </button>
          </div>

          <button
            className="hidden md:w-[150px] h-10 md:flex items-center justify-center gap-2 border border-gray-300 bg-four text-secondary font-medium text-sm rounded-md hover:opacity-90 transition"
            onClick={() => setShowAll(!showAll)}
          >
            <span>View all</span>
            <IoIosArrowUp
              fontSize={20}
              className={`transition-transform duration-300 ${
                showAll ? "rotate-180" : ""
              }`}
            />
          </button>
        </div>
      </div>
      {viewType === "grid" ? (
        <div className=" flex flex-col gap-3 mt-5">
                
                   <div className={`grid gap-5  mt-5
    grid-cols-2 
    ${showShareModal || showInfoModal || showFilter 
      ? "md:grid-cols-4 w-[80%]" 
      : "sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 w-full  "
    }`}>
                     {items
                       .filter((file) => !file.trashed)
                       .filter(
                         (file) =>
                           search?.toLowerCase() === "" ||
                           file.name?.toLowerCase().includes(search.toLowerCase())
                       )
                       .slice(0, showAll ? items.length : 5)
                       .map((file) => {
                         const fileId = file._id || file.id;
                           const isSelected = selectedItems.includes(fileId);
                         const handleRenameConfirm = () => {
                           if (renameValue.trim()) {
                             setFiles((prev) =>
                               prev.map((f) =>
                                 f._id === file._id
                                   ? { ...f, name: renameValue.trim() }
                                   : f
                               )
                             );
                           }
                           setRenamingId(null);
                         };
       
                         return (
                           <FileContainer key={fileId} className={` group cursor-pointer border p-2 rounded-md transition-all duration-300 ${
                     isSelected
                       ? "ring-2 ring-blue-500 bg-blue-50"
                       : "hover:ring-1 hover:ring-gray-400"
                   }`}>
                    { checkboxOpen && <div className=" top-2 right-3 z-10">
                     <input
                       type="checkbox"
                       checked={isSelected}
                       onChange={() => toggleSelection(fileId)}
                       className="w-4 h-4 text-blue-600 border-gray-300 rounded"
                     />
                   </div> }
                             <div className="w-10 h-12  ">
                               <img
                                 className={`w-full h-full object-contain rounded-md ${
                                   file.isLocked ? "blur-sm opacity-60" : ""
                                 }`}
                                 onClick={() => {
                                   if (file.isLocked && file.privacy === "private") {
                                     const entered = prompt("Enter password:");
                                     if (entered === file.password)
                                       handleItemClick(file);
                                     else alert("Incorrect password");
                                   } else {
                                     handleItemClick(file);
                                   }
                                 }}
                                 src={getFileIcon(file.name, file.url)}
                                 alt={file.name}
                               />
                             </div>
       
                            
                             {renamingId === file._id ? (
                               <input
                                 autoFocus
                                 value={renameValue}
                                 onChange={(e) => setRenameValue(e.target.value)}
                                 onBlur={() => setRenamingId(null)}
                                 onKeyDown={(e) => {
                                   if (e.key === "Enter") handleRenameConfirm();
                                   else if (e.key === "Escape") setRenamingId(null);
                                 }}
                                 className="text-sm border outline-none  px-2 py-1 w-full rounded-md"
                               />
                             ) : (
                               <span
                                 className=" font-medium text-sm truncate cursor-pointer"
                                 onClick={() =>
                                   !file.isLocked &&
                                   (file.isDirectory
                                     ? handleFolderClick(file)
                                     : handleItemClick(file))
                                 }
                               >
                                 {file.name.slice(0, 20)}
                               </span>
                             )}
       
                            
                             <div className="flex justify-between text-[11px] text-gray-600 w-full">
                               {(() => {
                                 const filtered = items.filter(
                                   (f) => f.parentId === file._id
                                 );
                                 const totalSize = filtered.reduce(
                                   (acc, cur) => acc + (cur.size || 0),
                                   0
                                 );
                                 return (
                                   <>
                                     <span>{filtered.length} items</span>
                                     <span>{formatBytes(totalSize)}</span>
                                   </>
                                 );
                               })()}
                             </div>
                             <div className="absolute top-2 right-2 flex space-x-2 text-black">
                               <button>
                                 <FaRegStar />
                               </button>
                               <button
                                 onClick={() =>
                                   setMenuOpenId(menuOpenId === fileId ? null : fileId)
                                 }
                               >
                                 <HiDotsVertical fontSize={20} />
                               </button>
                             </div>
       
                            
                             {menuOpenId === fileId && (
                               <MenuComponent
                                 file={file}
                                 setMenuOpenId={setMenuOpenId}
                                 renameValue={renameValue}
                                 setRenameValue={setRenameValue}
                                 setRenamingId={setRenamingId}
                                 showShareModal={showShareModal}
                                 infoModel={infoModel}
                                 setInfoModel={setInfoModel}
                                 setShowShareModal={setShowShareModal}
                                 showInfoModal={showInfoModal}
                                 setShowInfoModal={setShowInfoModal}
                                 setInfoFile={setInfoFile}
                               />
                             )}
                             {showShareModal && (
                               <ShareView
                                 setIsOpen={setShowShareModal}
                                 handleShare={() => {
                                   toast.success("File shared successfully!");
                                   setShowShareModal(false);
                                 }}
                               />
                             )}
       
                             {showInfoModal && infoFile && (
                               <FileInformation
                                 showInfoModal={showInfoModal}
                                 infoFile={infoFile}
                                 onClose={() => setShowInfoModal(false)}
                               />
                             )}
       
                             {showMoveModal && selectedForMove && (
                               <MoveModal
                                 file={selectedForMove}
                                 folders={files.filter(
                                   (f) => f.isDirectory && !f.trashed
                                 )}
                                 onClose={() => setShowMoveModal(false)}
                                 onMove={(destinationId) => {
                                   setFiles((prev) =>
                                     prev.map((f) =>
                                       f._id === selectedForMove._id
                                         ? { ...f, parentId: destinationId }
                                         : f
                                     )
                                   );
                                   setShowMoveModal(false);
                                   toast.success("Moved successfully");
                                 }}
                               />
                             )}
                           </FileContainer>
                         );
                       })}
                   </div>
                 </div>
      ) : (
        <div>
          <div className="w-full overflow-x-auto mt-5">
                     <table
                       className="min-w-[700px] w-full table-auto  text-sm text-left"
                       ref={menuRef}
                     >
                       <thead className=" text-xs md:text-sm">
                         <tr className="text-secondary font-semibold">
                           {["Name", "Created At", "Main Access", "Size", "More"].map(
                             (col, i) => (
                               <th key={i} className="p-2 md:p-4 whitespace-nowrap text-secondary ">
                                 {col}
                               </th>
                             )
                           )}
                         </tr>
                       </thead>
         
                      
                       <tbody>
                         {items
                           .filter((file) => !file.trashed)
                           .filter((item) => item.type === "folder")
         
                           .slice(0, showAll ? items.length : 5)
                           .map((file, index) => {
                             const fileId = file.id || file._id;
         
                             return (
                               <tr key={fileId} className="hover:bg-third">
                                 <td className="p-2 md:p-4 text-secondary">
                                   <div className="flex items-center gap-4">
                                     <div className="relative w-8 h-8 md:w-10 md:h-10">
                                       {file.isLocked && (
                                         <FaLock
                                           className="absolute top-0 left-0 text-red-500 z-10"
                                           fontSize={14}
                                         />
                                       )}
                                       <img
                                         src={getFileIcon(file.name, file.url)}
                                         alt={file.name}
                                         onClick={() => handleItemClick(file)}
                                         className={`w-full h-full rounded-md object-cover transition-all duration-300 ${
                                           file.isLocked && !file.isDirectory
                                             ? "blur-md opacity-50 cursor-not-allowed"
                                             : ""
                                         }`}
                                       />
                                     </div>
                                     <span
                                       className="cursor-pointer font-medium text-secondary text-sm truncate max-w-[150px]"
                                       onClick={() =>
                                         !file.isLocked &&
                                         (file.isDirectory
                                           ? handleFolderClick(file)
                                           : setSelectedFile(file))
                                       }
                                     >
                                       {file.name.slice(0, 20)}
                                     </span>
                                   </div>
                                 </td>
         
                                
                                 <td className="p-2 md:p-4 text-secondary">
                                   {file.updatedAt?.slice(0, 10)}
                                 </td>
         
                               
                                 <td className="p-2 md:p-4 text-secondary">
                                   <div className="flex items-center gap-2">
                                     {value[index]?.profile && (
                                       <img
                                         src={value[index].profile}
                                         alt="profile"
                                         className="w-5 h-5 rounded-full"
                                       />
                                     )}
                                   
                                     {value[index]?.avatar && (
                                       <img
                                         src={value[index].avatar}
                                         alt="avatar"
                                         className="w-5 h-5 rounded-full"
                                       />
                                     )}
                                   </div>
                                   
                                 </td>
         
                                
                                 <td className="p-2 md:p-4 text-secondary">
                                   <div className="flex items-center gap-2">
                                     {value[index]?.avatar1 && (
                                       <img
                                         src={value[index].avatar1}
                                         alt="avatar"
                                         className="w-5 h-5 rounded-full"
                                       />
                                     )}
                                     <span>{value[index]?.size || "--"}</span>
                                   </div>
                                   
                                 </td>
         
                                
                                 <td className="p-2 md:p-4 text-secondary">
                                   <div
                                     className="inline-flex items-center justify-center text-sm text-secondary font-medium cursor-pointer"
                                     onClick={() =>
                                       setMenuOpenId(
                                         menuOpenId === fileId ? null : fileId
                                       )
                                     }
                                   >
                                     <HiDotsVertical fontSize={20} />
                                   </div>
         
                                   {menuOpenId === fileId && (
                                     <MenuComponent
                                       file={file}
                                       setMenuOpenId={setMenuOpenId}
                                       renameValue={renameValue}
                                       setRenameValue={setRenameValue}
                                       setRenamingId={setRenamingId}
                                       showShareModal={showShareModal}
                                       infoModel={infoModel}
                                       setInfoModel={setInfoModel}
                                       setShowShareModal={setShowShareModal}
                                       showInfoModal={showInfoModal}
                                       setShowInfoModal={setShowInfoModal}
                                       setInfoFile={setInfoFile}
                                     />
                                   )}
         
                                   {showShareModal && (
                                     <ShareView
                                       setIsOpen={setShowShareModal}
                                       handleShare={() => {
                                         toast.success("File shared successfully!");
                                         setShowShareModal(false);
                                       }}
                                     />
                                   )}
         
                                   <FileInformation
                                     showInfoModal={showInfoModal}
                                     infoFile={infoFile}
                                     onClose={() => setShowInfoModal(false)}
                                   />
         
                                   {showMoveModal && selectedForMove && (
                                     <MoveModal
                                       file={selectedForMove}
                                       folders={files.filter(
                                         (f) => f.isDirectory && !f.trashed
                                       )}
                                       onClose={() => setShowMoveModal(false)}
                                       onMove={(destinationId) => {
                                         setFiles((prev) =>
                                           prev.map((f) =>
                                             f._id === selectedForMove._id
                                               ? { ...f, parentId: destinationId }
                                               : f
                                           )
                                         );
                                         setShowMoveModal(false);
                                         toast.success("Moved successfully");
                                       }}
                                     />
                                   )}
                                 </td>
                               </tr>
                             );
                           })}
         
                       
                         {isPopupOpen && (
                           <tr>
                             <td colSpan={5}>
                               <DeleteView
                                 handleDeleteCancel={handleDeleteCancel}
                                 handleDeleteConfirm={handleDeleteConfirm}
                               />
                             </td>
                           </tr>
                         )}
                       </tbody>
                     </table>
                   </div>
        </div>
      )}
    </div>
  );
};

export default MyDrive;
